export const dailyThoughts = [
  {
    id: '2024-01-02-1',
    date: '2024-01-02',
    time: '10:30 PM',
    thought: 'Building in public feels different. Raw thoughts → refined ideas.'
  },
  {
    id: '2024-01-02-2',
    date: '2024-01-02',
    time: '11:15 PM',
    thought: 'The best ideas come when you\'re not trying to be profound.'
  }
];
